import { render } from "./blog-hero-new.vue?vue&type=template&id=6321ad3e&scoped=true"
import script from "./blog-hero-new.vue?vue&type=script&lang=js"
export * from "./blog-hero-new.vue?vue&type=script&lang=js"

import "./blog-hero-new.vue?vue&type=style&index=0&id=6321ad3e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6321ad3e"]])

export default __exports__